import { Button } from '@mui/material';
import { ShieldOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ACCOUNT_PATH } from '../../config/routePermissions';
import { useLogout } from '../../lib/useLogout';

/**
 * Lo que ve un operador sin rol en el centro, o con su rol desactivado, en
 * cualquier página protegida: una explicación y no un error. `/v8/manager/me`
 * sólo trae `permissions: []`, así que los dos casos se cuentan juntos.
 *
 * Gemela de `NoPermissionsScreen` de sporttia-manager, con sus mismos textos.
 * No lleva el aviso de que la pantalla se actualiza sola: aquí los permisos se
 * leen al entrar y no se vuelven a pedir.
 */
export default function NoPermissionsScreen(): React.ReactElement {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const logout = useLogout();

    return (
        <div className="flex justify-center px-4 py-16">
            <div className="flex max-w-md flex-col items-center gap-6 text-center">
                <div className="flex flex-col items-center gap-2">
                    <div className="bg-muted text-foreground mb-2 flex h-10 w-10 items-center justify-center rounded-lg">
                        <ShieldOff className="h-6 w-6" aria-hidden />
                    </div>
                    <h1 className="m-0 text-lg font-medium">
                        {t('noPermissions.title')}
                    </h1>
                    <p className="text-muted-foreground m-0 text-sm">
                        {t('noPermissions.description')}
                    </p>
                </div>

                <div className="bg-muted flex w-full flex-col gap-1 rounded-md p-4 text-left text-sm">
                    <span className="font-medium">
                        {t('noPermissions.whatToDo')}
                    </span>
                    <span className="text-muted-foreground">
                        {t('noPermissions.whatToDoDescription')}
                    </span>
                </div>

                <div className="flex gap-2">
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => navigate(ACCOUNT_PATH)}
                    >
                        {t('noPermissions.account')}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={logout}
                    >
                        {t('noPermissions.logout')}
                    </Button>
                </div>
            </div>
        </div>
    );
}
